export const variantColumns = [
  { id: "incoming", title: "Incoming", tooltipContent: "Outstanding quantities on ordered purchase orders" },
  { id: "min", title: "Min quantity" },
  { id: "warehouse_location", title: "Warehouse location" },
] as const;

export type VariantColumn = (typeof variantColumns)[number];
